import { StaticImage } from "gatsby-plugin-image";
import React, { useContext } from "react";
import { AwsLogo } from "../icons/AwsLogo/AwsLogo";
import { InstagramLogo } from "../icons/InstagramLogo/InstagramLogo";
import { LinkedInLogo } from "../icons/LinkedInLogo/LinkedInLogo";
import environments from "../../utils/config/environments";
import { LangContext } from "../../context/lang/LangContext";

export const Footer = () => {
  const { messages } = useContext(LangContext);

  return (
    <footer className="Footer">
      <div className="Footer__logo_container">
        <StaticImage
          layout="constrained"
          src="../../images/c4c7us-logo.png"
          alt="logo"
          className="Footer__logo"
        />
      </div>
      <div className="Footer__media_container">
        <div className="Footer__media_item">
          {messages.footer.copies.allRightsReserved}
        </div>
        <div className="Footer__media_item Footer__media_item_aws">
          {messages.footer.copies.poweredBy}
          <AwsLogo />
        </div>
        <div className="Footer__media_item Footer__media_item_contact_us">
          <span>{messages.footer.copies.contactUs}</span>
          <a rel="noreferrer" href={environments.instagramLink} target="_blank">
            <InstagramLogo />
          </a>
          <a rel="noreferrer" href={environments.linkedInLink} target="_blank">
            <LinkedInLogo />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
